import * as XLSX from 'xlsx';

export function exportExcel(panier, formatSpot) {

  const wb = XLSX.utils.book_new();
  wb.Props = {
    Title: "Simulation",
    Author: "Mediavision",
    CreatedDate: new Date()
  };

  wb.SheetNames.push("Simulation");

  // Header
  const data = [
    ["", "Annonceur:","","Format spot écran:", "", "Date de simulation:", ""],
    ["", "", "", formatSpot, "", new Intl.DateTimeFormat("fr-FR").format(new Date()), ""],
    ["", "", "", "", "", "", ""],
    ["", "Produit", "Pression", "Semaine", "Type d'audience", "Audience", "Tarif brut"]
  ];

  let tarif = 0;
  let audience = 0;

  panier.forEach(produitPanier => {
    data.push(
      ["", produitPanier.produit.libelle, produitPanier.pression, produitPanier.semaine.numero, produitPanier.produit.audienceLibelle, produitPanier.audience(), produitPanier.tarif(formatSpot)]
    );
    tarif += produitPanier.tarif(formatSpot);
    audience += produitPanier.audience();
  });

  // Total
  data.push(["", "", "", "", "", "", ""]);
  data.push(["", "TOTAL", "", "", "", audience, tarif]);

	const sheet_data = XLSX.utils.aoa_to_sheet(data);
  wb.Sheets["Simulation"] = sheet_data;

  return XLSX.write(wb, {bookType:'xlsx', bookSST:true, type: 'base64'});

}
